import { render } from "./Publication.vue?vue&type=template&id=3ea995aa&scoped=true"
import script from "./Publication.vue?vue&type=script&lang=js"
export * from "./Publication.vue?vue&type=script&lang=js"

import "./Publication.vue?vue&type=style&index=0&id=3ea995aa&lang=scss&scoped=true"

import exportComponent from "/home/knavarro/Proyectos/IGP/programas-investigacion/cts-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea995aa"]])

export default __exports__